import React from 'react';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import { PHONEMASK } from 'utils/Misc/CommonConstants';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

const BodyStyle = styled.div`
	display: flex;
	flex-direction: column;
	height: 325px;
	padding-bottom: 50px;
	input {
		color: ${props => props.theme.defaultFontColor};
	}

	.ScrollbarsCustom-Track {
		right: -15px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.account} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}
	.text,
	.terms {
		margin-top: 10px;
		margin-bottom: 10px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 300px;
		padding-bottom: 100px;
		.ScrollbarsCustom-Track {
			right: -15px !important;
			top: 0px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 8px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 8px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 460px;
		padding-bottom: 100px;
		.ScrollbarsCustom-Track {
			right: -15px !important;
			top: 0px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 10px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 10px !important;
		}
		.text,
		.terms {
			margin-top: 20px;
			margin-bottom: 20px;
		}
	}
`;

export const MFAModalBody = ({ text, onChange }) => {
	return (
		<BodyStyle>
			<ScrollView>
				<div className='text body10'>{text}</div>
				<MaskedInput
					className='mfa-text body10'
					mask={PHONEMASK}
					placeholder='Mobile number'
					onChange={onChange}
				/>
				<div className='terms'>
					<div className='labels21s'>Terms</div>
					<div className='text body10'>
						By adding a viable mobile phone number to your account, you give express consent that
						the DC BLOX may send you informational text (SMS) messages as part of the normal
						business operation of your use of the MyDCBLOX ("Service") and that use of SMS is
						necessary to utilize the Services. When you access an account, we will send you an SMS
						message to the mobile phone number containing your access token. You can cancel the SMS
						service at any time by removing your mobile phone number from your profile. After this,
						you will no longer receive SMS messages from us. If you want to join again, just sign up
						as you did the first time and we will start sending SMS messages to you again. Message
						frequency depends on your use of the Services. If you have any questions about your text
						plan or data plan, please contact your wireless provider.
					</div>
				</div>
			</ScrollView>
		</BodyStyle>
	);
};
